import { type Middleware } from 'redux';
import { createLogger } from 'redux-logger';
import { getLoggedActionType } from './getLoggedActionType';

// @ts-expect-error
export const loggerMiddleware: Middleware = createLogger({
  actionTransformer(action) {
    return {
      ...action,
      type: getLoggedActionType(action),
    };
  },
});
